import { appendBrandNameIfPresent, PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import graphqlInstance from "../../config/graphqlConfig";
import {
  CREATE_SECRET,
  CREATE_TAG,
  DELETE_TAG,
  GET_SECRET,
  PUBLISH_COOKIE_SETTING,
  PUBLISH_FOOTER_SETTING,
  PUBLISH_GLOBAL_SETTING,
  PUBLISH_HEADER_SETTING,
  PUBLISH_MEDIA_HANDLE,
  PUBLISH_TAG,
  UPDATE_COOKIE_POLICY,
  UPDATE_FOOTER_SETTING,
  UPDATE_GLOBAL_SETTING,
  UPDATE_HEADER_SETTING,
  UPDATE_MEDIA_HANDLE,
} from "../../graphQL/mutations/siteSettingMutations";
import {
  FETCH_ADMIN_DOMAIN,
  FETCH_CATEGORY,
  FETCH_COOKIE_POLICY,
  FETCH_COUNTRY,
  FETCH_FOOTER_SETTING,
  FETCH_GLOBAL_SETTING,
  FETCH_HEADER_SETTING,
  FETCH_MEDIA_HANDLE,
  FETCH_MULTISITE_LISTING,
  FETCH_TAG_LISTING,
  FETCH_USER_SITE,
} from "../../graphQL/queries/siteSettingQueries";
import { FETCH_SITE_LISTING } from "../../graphQL/queries/siteCreationQueries";
import {
  BrightcoveConfig,
  PublisherIdentity,
  resolveLogoUrl,
  writeBrightcoveConfig,
  writePublisherIdentity,
} from "../../utils/structuredData";
import { ApiResponse } from "../../utils/types";

const withBrandName = (input: any): any => {
  if (!input?.input) return input;
  return { ...input, input: appendBrandNameIfPresent(input.input) };
};

export const fetchFooterSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_FOOTER_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchFooterSetting`, err);
    throw err;
  }
};

export const updateSiteSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_FOOTER_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateSiteSetting`, err);
    throw err;
  }
};

export const publishFooterSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_FOOTER_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishFooterSetting`, err);
    throw err;
  }
};

export const updateHeaderSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_HEADER_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateHeaderSetting`, err);
    throw err;
  }
};

export const updateGlobalSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_GLOBAL_SETTING,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateGlobalSetting`, err);
    throw err;
  }
};

export const fetchMediaHandle = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_MEDIA_HANDLE,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchMediaHandle`, err);
    throw err;
  }
};

export const updateMediaHanle = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_MEDIA_HANDLE,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:updateMediaHanle`, err);
    throw err;
  }
};

export const publishMediaHanle = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_MEDIA_HANDLE,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishMediaHanle`, err);
    throw err;
  }
};

export const fetchCookiePolicy = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_COOKIE_POLICY,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchCookiePolicy`, err);
    throw err;
  }
};

export const mutateCookiePolicy = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: UPDATE_COOKIE_POLICY,
      variables: withBrandName(input),
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:mutateCookiePolicy`, err);
    throw err;
  }
};

export const publishCookiePolicy = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_COOKIE_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishCookiePolicy`, err);
    throw err;
  }
};

export const fetchCountries = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_COUNTRY,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchCountries`, err);
    throw err;
  }
};
export const fetchHeaderSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_HEADER_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchHeaderSetting`, err);
    throw err;
  }
};

export const fetchGlobalSetting = async <T>(input: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_GLOBAL_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchGlobalSetting`, err);
    throw err;
  }
};

export const fetchGlobalSettingWithHeader = async <T>(input: T, headers: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_GLOBAL_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
      context: headers,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchGlobalSettingWithHeader`, err);
    throw err;
  }
};

export const fetchHeaderSettingWithHeader = async <T>(input: T, headers: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_HEADER_SETTING,
      variables: input,
      fetchPolicy: "no-cache",
      context: headers,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchHeaderSettingWithHeader`, err);
    throw err;
  }
};

export const fetchSiteInfoWithHeader = async <T>(input: T, headers: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_SITE_LISTING,
      variables: input,
      fetchPolicy: "no-cache",
      context: headers,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchSiteInfoWithHeader`, err);
    throw err;
  }
};

export const getSecretWithHeader = async <T>(input: T, headers: T): Promise<any> => {
  try {
    const { data } = await graphqlInstance.query({
      query: GET_SECRET,
      variables: input,
      fetchPolicy: "no-cache",
      context: headers,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getSecretWithHeader`, err);
    throw err;
  }
};

export const publishHeaderSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_HEADER_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishHeaderSetting`, err);
    throw err;
  }
};

export const publishGlobalSetting = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.mutate({
      mutation: PUBLISH_GLOBAL_SETTING,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:publishGlobalSetting`, err);
    throw err;
  }
};

export const fetchMultisiteListing = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_MULTISITE_LISTING,
      variables: input,
      fetchPolicy: "no-cache",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchMultisiteListing`, err);
    throw err;
  }
};

export const fetchAdminDomainList = async <T>(): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_ADMIN_DOMAIN,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchAdminDomainList`, err);
    throw err;
  }
};

export const fetchUserSitePermissionList = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_USER_SITE,
      variables: input,
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchUserSitePermissionList`, err);
    throw err;
  }
};

/**
 * Resolves the JSON-LD `publisher` identity (site display name + absolute logo
 * URL) for `sitename` and caches it for the synchronous structured-data
 * builders in `utils/structuredData`.
 *
 * ⚠️ Multi-tenant: both queries MUST carry the explicit `sitename` header. The
 * Apollo header link otherwise defaults to the session-derived
 * `getSelectedSite()`, which during a site switch still resolves to the
 * PREVIOUS site — that would publish one customer's name and logo on another
 * customer's pages. `sitename` comes from the session's accessible sites, never
 * from a caller-supplied parameter.
 *
 * Fails closed: anything unresolvable clears the cache instead of leaving the
 * previous tenant's branding behind, and the builders then omit `publisher`.
 */
export const cachePublisherIdentity = async (sitename: any) => {
  // The admin console authors no content, so it has no publisher to cache —
  // and leaving the previous site's value behind would be a cross-tenant leak.
  if (!sitename || String(sitename).toLowerCase() === "system") {
    writePublisherIdentity(undefined);
    return undefined;
  }

  const headerContext = {
    useProvidedSiteNameHeader: true,
    headers: { sitename },
  };

  const [siteInfoResult, headerSettingResult] = await Promise.allSettled([
    fetchSiteInfoWithHeader({ page: sitename }, headerContext as any),
    fetchHeaderSettingWithHeader({ page: "header-item" }, headerContext as any),
  ]);

  const siteInfo =
    siteInfoResult.status === "fulfilled" ? siteInfoResult.value?.authoring_getSitedetails : null;
  const headerSetting =
    headerSettingResult.status === "fulfilled"
      ? headerSettingResult.value?.authoring_getSitedetails
      : null;

  // The site slug is a correct-if-plain fallback; it always names THIS tenant.
  const name = siteInfo?.site_title || sitename || "";
  const logoUrl = resolveLogoUrl(headerSetting?.header_logo || headerSetting?.header_favicon);

  const identity: PublisherIdentity | undefined = name ? { name, logoUrl } : undefined;
  writePublisherIdentity(identity);
  return identity;
};

/**
 * Resolves and caches the tenant's PUBLIC Brightcove ids (account + player) so
 * the VOD structured-data builder can construct `embedUrl` synchronously.
 *
 * ⚠️ Same multi-tenant rule as `cachePublisherIdentity`: the explicit `sitename`
 * header is mandatory. A stale account id would point every VOD's `embedUrl` at
 * another customer's Brightcove account. Only the two public ids are read — the
 * client id/secret on the same record are ignored.
 */
export const cacheBrightcoveConfig = async (sitename: any) => {
  if (!sitename || String(sitename).toLowerCase() === "system") {
    writeBrightcoveConfig(undefined);
    return undefined;
  }

  try {
    const response = await getSecretWithHeader({ provider: "brightcove", providerType: "video" }, {
      useProvidedSiteNameHeader: true,
      headers: { sitename },
    } as any);
    const requiredParams = response?.authoring_getSecret?.requiredParams;
    const accountId = requiredParams?.account_id?.value || "";
    const config: BrightcoveConfig | undefined = accountId
      ? { accountId, playerId: requiredParams?.player_id?.value || "" }
      : undefined;
    writeBrightcoveConfig(config);
    return config;
  } catch (error) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:cacheBrightcoveConfig`, error);
    writeBrightcoveConfig(undefined);
    return undefined;
  }
};

/**
 * Everything the synchronous structured-data builders read from cache, refreshed
 * for one tenant. Settled in parallel so neither half can block the other, and
 * so a site switch never inherits half of the previous tenant's identity.
 */
export const cacheStructuredDataContext = async (sitename: any) => {
  await Promise.allSettled([cachePublisherIdentity(sitename), cacheBrightcoveConfig(sitename)]);
};

export const getGlobalDataWithHeader = async (sitename: any) => {
  try {
    const { authoring_getSitedetails = {} } = await fetchGlobalSettingWithHeader(
      {
        page: "global-item",
      },
      {
        // The Apollo header link defaults `sitename` to the session-derived
        // getSelectedSite(), which during a site switch still resolves to the
        // PREVIOUS site. Flag the provided header so the target site's DAM
        // community mapping is fetched, not the old one.
        useProvidedSiteNameHeader: true,
        headers: {
          sitename: sitename,
        },
      },
    );
    const imageUuid = authoring_getSitedetails?.image?.slice(-1)?.[0]?.ScopeId;
    const videoUuid = authoring_getSitedetails?.video?.slice(-1)?.[0]?.ScopeId;
    const documentUuid = authoring_getSitedetails?.misc?.slice(-1)?.[0]?.ScopeId;

    // Write the new site's mapping, but if this site has no mapping REMOVE the
    // stale value instead of leaving the previous site's uuid behind. AUTH_INFO
    // then resolves to "" and the Asset Manager fails closed, rather than
    // showing another tenant's community.
    imageUuid ? localStorage.setItem("imageUuid", imageUuid) : localStorage.removeItem("imageUuid");
    videoUuid ? localStorage.setItem("videoUuid", videoUuid) : localStorage.removeItem("videoUuid");
    documentUuid
      ? localStorage.setItem("documentUuid", documentUuid)
      : localStorage.removeItem("documentUuid");

    localStorage.setItem("siteTheme", authoring_getSitedetails?.site_theme || "LIGHT");
    return {};
  } catch (error) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:getGlobalDataWithHeader`, error);
    return {};
  } finally {
    // Refresh the cached JSON-LD context (publisher identity + Brightcove ids)
    // for the site being switched into. In `finally` on purpose: even when the
    // branding fetch above fails we must not leave the PREVIOUS tenant's name,
    // logo or video account cached, and the isolation keeps a failure here off
    // the login/site-switch critical path.
    try {
      await cacheStructuredDataContext(sitename);
    } catch (error) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:cacheStructuredDataContext`, error);
      writePublisherIdentity(undefined);
      writeBrightcoveConfig(undefined);
    }
  }
};

export const fetchTagListing = async <T>(input: T): Promise<ApiResponse<T>> => {
  try {
    const { data } = await graphqlInstance.query({
      query: FETCH_TAG_LISTING,
      variables: input,
      fetchPolicy: "network-only",
    });
    return data;
  } catch (err: any) {
    console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:fetchTagListing`, err);
    throw err;
  }
};

export const fetchCategory = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.query({
    query: FETCH_CATEGORY,
    variables: input,
    fetchPolicy: "network-only",
  });
  return data;
};

export const createTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: CREATE_TAG,
    variables: input,
  });
  return data;
};

export const publishTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: PUBLISH_TAG,
    variables: input,
  });
  return data;
};

export const deleteTag = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: DELETE_TAG,
    variables: input,
  });
  return data;
};
export const createSecrete = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.mutate({
    mutation: CREATE_SECRET,
    variables: input,
  });
  return data;
};
export const getSecrate = async <T>(input: T): Promise<ApiResponse<T>> => {
  const { data } = await graphqlInstance.query({
    query: GET_SECRET,
    variables: input,
    fetchPolicy: "network-only",
  });
  return data;
};

type SecretVars = { provider: string; providerType: string };
export const getSecretsMerged = async (inputs: SecretVars[]): Promise<any[]> => {
  const results = await Promise.all(
    inputs.map(async ({ provider, providerType }) => {
      const { data } = await graphqlInstance.query({
        query: GET_SECRET,
        variables: { provider, providerType },
      });
      return data?.authoring_getSecret;
    }),
  );
  return results;
};
